<!-- <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB"> -->
  ...
  <!-- <div class="input-card py-2">
    ...
  </div> -->
<!-- </div> -->